import { FormattedMessage, useIntl } from 'react-intl'

import { ButtonGroup } from 'Components/_theme'

import type { RequestPurchaseModalConfirmationProps } from '../RequestPurchaseModal.types'

export const RequestPurchaseModalConfirmation = (
  props: RequestPurchaseModalConfirmationProps,
) => {
  const { onHide } = props

  const intl = useIntl()

  return (
    <>
      <span aria-live="polite" role="status">
        <p>
          <FormattedMessage id="RequestPurchaseModal_confirmationTitle" />
        </p>

        <p>
          <FormattedMessage id="RequestPurchaseModal_confirmationDescription" />
        </p>
      </span>

      <ButtonGroup
        rightButton={{
          onClick: onHide,
          text: intl.formatMessage({ id: 'Close' }),
        }}
      />
    </>
  )
}
